import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { unstable_useNumberInput as useNumberInput } from "@mui/base/unstable_useNumberInput";
import { TextField } from "@mui/material";
import { Filter } from "./datafilter-types";

interface NumberFilterProps {
  filter: Filter;
  // We also return val as a string in case the user is still typing
  // and we want to show the trailing decimal point
  onChangeNumber: (name: string, val: number | string | null) => void;
}

const NumberFilter: (props: NumberFilterProps) => JSX.Element = ({
  filter,
  onChangeNumber,
}) => {
  const [displayValue, setDisplayValue] = React.useState<string>("");
  const { getRootProps, getInputProps, focused } = useNumberInput({
    onInputChange(event) {
      const { value } = event.target;

      if (value === "") {
        onChangeNumber(filter.name, null);
        setDisplayValue("");
        return;
      }

      // Check if input is valid number format (can have one decimal point)
      if (/^[0-9]*\.?[0-9]*$/.test(value)) {
        if (value.endsWith(".")) {
          // Display trailing decimal point but don't convert to number yet
          onChangeNumber(filter.name, value);
          setDisplayValue(value);
        } else {
          // Convert to number if it's a valid numeric value
          const parsedValue = parseFloat(value);
          if (!Number.isNaN(parsedValue)) {
            onChangeNumber(filter.name, parsedValue);
            setDisplayValue(value);
          } else {
            onChangeNumber(filter.name, value);
            setDisplayValue(value);
          }
        }
      }
    },
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { value, ...inputProps } = getInputProps();
  const { name, placeholder } = filter;
  return (
    <TextField
      focused={focused}
      aria-label={placeholder}
      {...getRootProps()}
      inputProps={{
        "data-testid": `${name}-input`,
        ...inputProps,
        value: displayValue,
      }}
      label={placeholder}
    />
  );
};

export default NumberFilter;
